// extracted by mini-css-extract-plugin
module.exports = {"tabs":"TabsMenu_tabs__8vuBZ","isActive":"TabsMenu_isActive__N8Cnf","indicator":"TabsMenu_indicator__M41UO"};